/**
 * ProductGroupsProvider
 * Contain most logic handing with Omnitech Api
 */

import React from 'react'
import ProductGroupsContext from './product-groups-context'
import {
  fetchProductGroup,
  fetchProductGroupByCode,
  fetchProductGroupLineByCode,
  fetchProductGroupLine
} from './product-groups-api'

export default function ProductGroupsProvider({ children }) {
  const state = {
    fetchProductGroup,
    fetchProductGroupByCode,
    fetchProductGroupLineByCode,
    fetchProductGroupLine
  }
  return (
    <ProductGroupsContext.Provider value={state}>
      {children}
    </ProductGroupsContext.Provider>
  )
}
